import React from "react";
import styled from "styled-components";
import {device} from "../../../../styles/BreakPoints";

const About = () => {
  return (
    <Section id="about">
      <Title>
        <span>01.</span> About Me
      </Title>
      <Wraper>
        <Content>
          <p>
            Hello! My name is Tushar and I enjoy creating things that live on
            the internet. My interest in web development started back in 2019
            when I decided to learn new things — found web development tutorials
            available on the internet that taught me a lot about HTML & CSS!
          </p>
          <p>
            Fast-forward to today, and I’ve had the privilege of working at
            <span>
              a digital agency, a start-up, a corporation, and a freelancing
              team
            </span>
            . My main focus these days is building accessible, inclusive
            products and digital experiences at Air Cyrus for a variety of
            clients.
          </p>

          <p>Here are a few technologies I’ve been working with recently:</p>

          <TechField>
            <li>Next.js</li>
            <li>React</li>
            <li>TypeScript</li>
            <li>JavaScript (ES6+)</li>
            <li>Node.js</li>
            <li>Express.js</li>
            <li>Prisma</li>
            <li>Mongoose</li>
            <li>Postgres</li>
            <li>MongoDB</li>
            <li>Rtk Query</li>
            <li>Redux toolkit</li>
          </TechField>
        </Content>
        <ImageContent>
          <ImageWraper>
            <img src="/img/me.jpg" alt="" />
          </ImageWraper>
        </ImageContent>
      </Wraper>
    </Section>
  );
};

export default About;

// styled components
const Section = styled.section`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  min-height: 100vh;
  margin: auto;
  max-width: 900px;
  margin: 0px 162px;
  padding: 100px 0px;

  @media ${device.xl} {
    margin: 0px 0px;
  }
  @media ${device.mdM} {
    padding: 80px 0px;
  }
`;
const Title = styled.h2`
  display: flex;
  align-items: center;
  position: relative;
  margin: 10px 0px 40px;
  width: 100%;
  font-size: clamp(26px, 5vw, var(--fz-heading));
  white-space: nowrap;
  font-family: ${(props) => props.theme.fonts.calibre_b};

  span {
    font-family: ${(props) => props.theme.fonts.sf};
    color: var(--green);
    margin-right: 10px;
    font-size: clamp(var(--fz-md), 3vw, var(--fz-xl));
    font-weight: 400;
    line-height: 1.1;
  }

  &::after {
    content: "";
    display: block;
    position: relative;
    /* top: -5px; */
    width: 300px;
    height: 1px;
    margin-left: 20px;
    background-color: var(--lightest-navy);
  }
`;
const Wraper = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 50px;

  @media ${device.mdM} {
    grid-template-columns: 1fr;
  }
`;
const Content = styled.div`
  p {
    margin: 0px 0px 15px;
    font-size: var(--fz-xl);
    line-height: 1.3;
    font-weight: 400;

    span {
      color: var(--green);
      margin-left: 5px;
    }
  }
`;

const ImageContent = styled.div`
  @media ${device.mdM} {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
const ImageWraper = styled.div`
  max-width: 300px;
  box-shadow: 0 10px 30px -15px var(--navy-shadow);
  transition: var(--transition);
  display: block;
  position: relative;
  width: 100%;
  border-radius: var(--border-radius);
  background-color: var(--green);

  &::before,
  &::after {
    top: 0px;
    left: 0px;
    background-color: var(--navy);
    mix-blend-mode: screen;
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: var(--border-radius);
    transition: var(--transition);
  }
  &::after {
    border: 2px solid var(--green);
    top: 20px;
    left: 20px;
    z-index: -1;
    background: none;
  }
  &:hover {
    background-color: white;
    &::after {
      top: 15px;
      left: 15px;
    }
    img {
      filter: none;
    }
  }
  img {
    position: relative;
    border-radius: var(--border-radius);
    mix-blend-mode: multiply;
    filter: grayscale(100%) contrast(1);
    transition: var(--transition);
  }
`;

const TechField = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, minmax(140px, 200px));
  gap: 0px 10px;
  padding: 0px;
  margin: 20px 0px 0px;
  overflow: hidden;
  list-style: none;

  li {
    position: relative;
    margin-bottom: 10px;
    padding-left: 20px;
    font-family: ${(props) => props.theme.fonts.sf};
    font-size: var(--fz-xs);
    color: var(--slate);

    &::before {
      content: "▹";
      position: absolute;
      left: 0px;
      color: var(--green);
      font-size: var(--fz-sm);
      line-height: 12px;
    }
  }
`;
